import type { Coverage, Quote } from "@/api_client";

// For a quote gets the displaynames of the selected coverages joined by ';' e.g 'coverageA;coverageB'
export const getCoverage = (
  product: Quote,
  coveragesByCoreName: Record<string, Coverage> | undefined,
) => {
  return (
    product.coverages
      ?.filter((coverage) => coverage.selected && !coverage.isAddon)
      .map(
        (coverage) =>
          coveragesByCoreName?.[coverage?.coverageName ?? ""]?.displayName
            ?.value ?? "",
      )
      .join(";") ?? ""
  );
};
